// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__33C1N","header":"ClearentDisclaimer_header__RrNZv","inner":"ClearentDisclaimer_inner__24rya"};